<template>
    <svg role="img" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 13.25 13.25" fill="none" aria-label="Calendar view icon">
        <rect x="0.625" y="2.625" width="12" height="10" rx="1" stroke="currentColor" stroke-width="1.25" />
        <line x1="0.625" y1="6" x2="12.625" y2="6" stroke="currentColor" stroke-width="1.25" />
        <path d="M3.625 2.625L3.625 0.625" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" />
        <path d="M9.625 2.625L9.625 0.625" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" />
    </svg>
</template>
